import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

export function NotFoundScreen() {
  return (
    <div className="mx-auto min-h-screen bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-gray-100">
      <div className="grid h-screen place-items-center">
        <div className="relative -top-20 flex flex-col items-center gap-1 text-center">
          <Icon icon="ic:round-heart-broken" className="text-7xl" />
          <div className="mb-3 text-2xl font-semibold">Page Not Found</div>
          <div>
            <Link
              to="/"
              reloadDocument
              className="inline-flex items-center gap-2 rounded-2xl bg-indigo-400 px-3 py-2 opacity-80 hover:opacity-100 dark:bg-indigo-600"
            >
              <Icon icon="material-symbols:home-rounded" />
              <span>Back to home</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
